import { render, staticRenderFns } from "./AddToJDSuccessSingle.vue?vue&type=template&id=35c1b0a0&"
import script from "./AddToJDSuccessSingle.vue?vue&type=script&lang=js&"
export * from "./AddToJDSuccessSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports